if (process.env.NODE_ENV !== 'production') {
  window.user = {
    first_name: 'SEHROB',
    last_name: 'IBROHIMOV',
    middle_name: 'MAXMADIYOROVICH',
    email: 'isehrob@gmail.com',
    current_address: 'Кашкадарья, Чирокчи р-н, Тарагай',
    gender: 'm',
    birthday: '1990-07-10',
    recipient_type_id: 'checked',
    juridical_name: '',
    pin_fl: '30705900171548',
    phone: '998935918467',
    region_id: 1,
    district_id: 1,
    mahalla_id: 3,
  };
  // window.user = null;
}

export const reshapeYear = (year) => {
  let yearList = year.split('-');
  return yearList[2] + '.' + yearList[1] + '.' + yearList[0];
};

export const reshapeGender = (gender) => gender.toLowerCase();

export const reshapePhone = (phone) => phone.replace(/[+\s-]/g, '');

export const reshapeAddress = (address) => {
  if (!address) return address;
  return address === 'undefined' ? undefined : address;
};

export const figureOutJuridical = (recpType) => recpType === 'checked';

export default (formName, formData = window.user) => {
  if (!formData) return null;

  let birthday = '';
  if (formData.birthday.includes('.')) {
    birthday = formData.birthday;
  } else {
    birthday = reshapeYear(formData.birthday);
  }
  let data = {
    [formName]: {
      ...formData,
      birthday,
      gender: reshapeGender(formData.gender),
      is_juridical: figureOutJuridical(formData.recipient_type_id),
      recipient_type_id: figureOutJuridical(formData.recipient_type_id) ? 2 : 1,
      current_address: reshapeAddress(formData.current_address),
      is_collective: 0,
      is_agree_electronically: true,
    },
  };

  if ('form_type' in formData) {
    data = {
      [formName]: {
        ...data[formName],
        is_juridical: formData.is_juridical,
      },
    };
    if (!!formData.persecution_authority_name && !!formData.persecution_request_no) {
      data = {
        [formName]: {
          ...data[formName],
          authority: formData.persecution_authority_name,
          request_no: formData.persecution_request_no,
        },
      };
    }
  }

  return data;
};

export const errorTypes = {
  is_public: 'isSecret',
  description: 'applicationLabel',
  first_name: 'name',
  middle_name: 'secondName',
  last_name: 'surname',
  current_address: 'address',
  birthday: 'birthdate',
  employment_id: 'status',
  juridical_name: 'entripName',
  mahalla_id: 'makhalla',
  country_id: 'country',
  region_id: 'region',
  district_id: 'district',
};



// WEBPACK FOOTER //
// ./src/application-form/utils.js